import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@node-space/ui-components'

export const PaymentCaseError = () => {
  const { t } = useTranslation()

  return (
    <>
      {t('paymentSupport.errorDescription')}{' '}
      <Button variant="ghost" noPadding onClick={() => window.location.reload()}>
        {t('paymentSupport.reloadPage')}
      </Button>
    </>
  )
}
